// 音の設定（全体・BGM・効果音）。起動画面の「音設定」と設定画面で共用
import { applyVolume, sfx } from '../audio';
import { setSetting, state } from '../state';
import { openModal } from './overlay';

const row = (k: 'master' | 'bgm' | 'sfx', label: string, v: number) =>
  `<label class="range snd-row"><span>${label}</span><input type="range" min="0" max="100" ${k === 'bgm' ? 'step="5"' : ''} value="${k === 'bgm' ? Math.round(v * 20) * 5 : Math.round(v * 100)}" data-k="${k}"><output>${k === 'bgm' ? Math.round(v * 20) : Math.round(v * 100)}</output></label>`;

export function soundRowsHtml(): string {
  const s = state.settings;
  return `${row('master', '全体', s.master ?? 1)}${row('bgm', 'BGM', s.bgm)}${row('sfx', '効果音', s.sfx)}`;
}

/** 音量のつまみを動かしたとき（data-k が master / bgm / sfx の range） */
export function bindSoundRows(root: HTMLElement) {
  root.addEventListener('input', (e) => {
    const t = e.target as HTMLInputElement;
    const k = t.dataset.k;
    if (k !== 'master' && k !== 'bgm' && k !== 'sfx') return;
    setSetting(k, Number(t.value) / 100);
    const out = t.nextElementSibling;
    // BGM は20段階（0〜20）で見せる
    if (out) out.textContent = k === 'bgm' ? String(Number(t.value) / 5) : t.value;
    applyVolume();
  });
  root.addEventListener('change', (e) => {
    const k = (e.target as HTMLInputElement).dataset.k;
    if (k === 'sfx' || k === 'master') sfx('tap');
  });
}

export function openSoundDialog(onClose?: () => void) {
  const m = openModal(`<div class="snd-box">${soundRowsHtml()}</div>`, { title: '音設定', className: 'sheet-wrap navy-sheet', onClose });
  bindSoundRows(m.body);
}
